import React from 'react';

const Button = ({ text, onClick, isActive }) => {
  const button = isActive ? 'bg-[#0AB7F1] text-white' : 'bg-white text-[#0AB7F1]';

  return (
    <button
      onClick={onClick}
      type="button"
      className={`${button} min-w-[180px] border border-[#0AB7F1] focus:outline-none font-medium rounded-lg text-xl px-6 py-4 mr-2 mb-2`}
    >
      {text}
    </button>
  );
};

export default Button;
